const ADD_TO_FAST_LINK = 'ADD_TO_FAST_LINK'
const INIT_FAST_LINK = 'INIT_FAST_LINK'

import { localstorage } from '@/helpers/localstorage'
import { toArray } from '@/helpers/toArray'

export default {
  namespaced: true,
  state: {},
  actions: {
    push({ commit }, data) {
      commit(ADD_TO_FAST_LINK, data)
    },
    init({ commit }, name) {
      commit(INIT_FAST_LINK, name)
    },
  },
  getters: {
    getFastLinks: state => (name, relation) => {
      const st = state[name] || []

      return relation ? st.filter(i => i.relation === relation).slice(0, 2) : st
    },
  },
  mutations: {
    [ADD_TO_FAST_LINK]: (state, data) => {
      if (data.item) {
        const arr = toArray(state[data.name], data.item)

        state[data.name] = arr
        localstorage.set('fastlink' + data.name, arr)
      }
    },
    [INIT_FAST_LINK]: (state, name) => {
      state[name] = localstorage.get('fastlink' + name)
    },
  },
}
